module.exports = __webpack_public_path__ + "ded5eb6c461f773922ede9d9fef5cb4d.png";